import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
/**
 * Use to conditionally wrap content. Use it rarely because it corrupts
 * readability!
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export function Wrap(props) {
    const { with: component, children } = props;
    if (React.isValidElement(component)) {
        return React.cloneElement(component, undefined, children);
    }
    return _jsx(_Fragment, { children: children });
}
export default Wrap;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV3JhcC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL1dyYXAvV3JhcC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLE9BQU8sS0FBMEMsTUFBTSxPQUFPLENBQUM7QUFFL0Q7OztHQUdHO0FBQ0gsZ0VBQWdFO0FBQ2hFLE1BQU0sVUFBVSxJQUFJLENBQ2xCLEtBQXlEO0lBRXpELE1BQU0sRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLFFBQVEsRUFBRSxHQUFHLEtBQUssQ0FBQztJQUU1QyxJQUFJLEtBQUssQ0FBQyxjQUFjLENBQUMsU0FBUyxDQUFDLEVBQUUsQ0FBQztRQUNwQyxPQUFPLEtBQUssQ0FBQyxZQUFZLENBQUMsU0FBUyxFQUFFLFNBQVMsRUFBRSxRQUFRLENBQUMsQ0FBQztJQUM1RCxDQUFDO0lBQ0QsT0FBTyw0QkFBRyxRQUFRLEdBQUksQ0FBQztBQUN6QixDQUFDO0FBRUQsZUFBZSxJQUFJLENBQUMifQ==